"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _checkCircle = _interopRequireDefault(require("react-icons/lib/fa/check-circle"));

var _delete = _interopRequireDefault(require("react-icons/lib/ti/delete"));

var _warning = _interopRequireDefault(require("react-icons/lib/ti/warning"));

var _pin = _interopRequireDefault(require("react-icons/lib/ti/pin"));

var _spinner = _interopRequireDefault(require("react-icons/lib/fa/spinner"));

require("rc-message/assets/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var prefix = "rc-message";

var RcMessage =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RcMessage, _PureComponent);

  function RcMessage(props) {
    var _this;

    _classCallCheck(this, RcMessage);

    _this = _possibleConstructorReturn(this, (RcMessage.__proto__ || Object.getPrototypeOf(RcMessage)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "state", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: {
        visible: true,
        value: ""
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "_container", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_dom", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "onOk", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var onOk = _this.props.onOk;
        var value = _this.state.value;

        _this.removeNode();

        onOk && onOk(value);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "onCancel", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var onCancel = _this.props.onCancel;

        _this.removeNode();

        onCancel && onCancel();
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "onInpChange", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({
          value: e.target.value
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "removeNode", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _reactDom.default.unmountComponentAtNode(_this._container);

        _this._dom.remove();
      }
    });
    _this.typeConfig = {
      info: "info",
      success: "success",
      error: "error",
      warning: "warning",
      loading: "loading",
      confirm: "confirm",
      prompt: "prompt"
    };
    _this.animationTime = 450;
    return _this;
  }

  _createClass(RcMessage, [{
    key: "componentWillUnMount",
    value: function componentWillUnMount() {
      document.body.removeChild(document.querySelector(".".concat(prefix)));
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      var container = Array.from(document.querySelectorAll(".".concat(prefix)));

      if (container.length < 1) {
        var div = document.createElement("div");
        div.className = prefix;
        document.body.appendChild(div);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.createContainer();
      var _props = this.props,
          duration = _props.duration,
          onClose = _props.onClose,
          type = _props.type;

      if (type !== this.typeConfig["confirm"] && type !== this.typeConfig["prompt"]) {
        this.timer = setTimeout(function () {
          _this2.setState({
            visible: false
          }, function () {
            setTimeout(function () {
              _this2.removeNode();
            }, _this2.animationTime);
            onClose && onClose();
          });
        }, duration * 1000);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          theme = _props2.theme,
          type = _props2.type,
          content = _props2.content,
          okText = _props2.okText,
          cancelText = _props2.cancelText,
          inputType = _props2.inputType,
          placeholder = _props2.placeholder;
      var visible = this.state.visible;
      var typeConfig = this.typeConfig;
      var isPrompt = type === typeConfig["prompt"];
      return _react.default.createElement("div", {
        key: "message",
        className: (0, _classnames.default)("".concat(prefix, "-content"), {
          "theme-dark": theme === "dark"
        }, {
          "theme-light": theme === "light"
        }, {
          open: visible
        }, {
          close: !visible
        })
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)("".concat(prefix, "-content-custom"), "message-".concat(typeConfig[type]))
      }, isPrompt ? undefined : _react.default.createElement("p", {
        className: "icon"
      }, type === typeConfig["info"] ? _react.default.createElement(_pin.default, null) : undefined, type === typeConfig["success"] ? _react.default.createElement(_checkCircle.default, null) : undefined, type === typeConfig["error"] ? _react.default.createElement(_delete.default, null) : undefined, type === typeConfig["warning"] ? _react.default.createElement(_warning.default, null) : undefined, type === typeConfig["loading"] ? _react.default.createElement(_spinner.default, null) : undefined, type === typeConfig["confirm"] ? _react.default.createElement(_warning.default, null) : undefined), _react.default.createElement("p", {
        className: "text"
      }, isPrompt ? _react.default.createElement(_pin.default, null) : undefined, _react.default.createElement("span", {
        className: "title"
      }, content)), isPrompt ? _react.default.createElement("p", {
        className: "input"
      }, _react.default.createElement("input", {
        type: inputType,
        placeholder: placeholder,
        onChange: this.onInpChange,
        className: "prompt-input"
      })) : undefined, type === typeConfig["confirm"] || isPrompt ? _react.default.createElement("div", {
        className: "confirm-footer"
      }, _react.default.createElement("button", {
        className: "btn confirm-btn btn-default",
        onClick: this.onCancel
      }, _react.default.createElement("span", null, cancelText)), _react.default.createElement("button", {
        className: "btn confirm-btn btn-primary",
        onClick: this.onOk
      }, _react.default.createElement("span", null, okText))) : undefined));
    }
  }], [{
    key: "error",
    value: function error(options) {
      this.renderElement("error", options);
    }
  }, {
    key: "info",
    value: function info(options) {
      this.renderElement("info", options);
    }
  }, {
    key: "success",
    value: function success(options) {
      this.renderElement("success", options);
    }
  }, {
    key: "warning",
    value: function warning(options) {
      this.renderElement("warning", options);
    }
  }, {
    key: "loading",
    value: function loading(options) {
      this.renderElement("loading", options);
    }
  }, {
    key: "confirm",
    value: function confirm(options) {
      this.renderElement("confirm", options);
    }
  }, {
    key: "prompt",
    value: function prompt(options) {
      this.renderElement("prompt", options);
    }
  }]);

  return RcMessage;
}(_react.PureComponent);

exports.default = RcMessage;
Object.defineProperty(RcMessage, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    content: _propTypes.default.string.isRequired,
    duration: _propTypes.default.number.isRequired,
    theme: _propTypes.default.oneOf(["light", "dark"]),
    onClose: _propTypes.default.func,
    onOk: _propTypes.default.func,
    onCancel: _propTypes.default.func,
    inputType: _propTypes.default.string,
    placeholder: _propTypes.default.string
  }
});
Object.defineProperty(RcMessage, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    okText: "Ok",
    cancelText: "Cancel",
    type: "info",
    content: "",
    duration: 2,
    theme: "light",
    inputType: "text"
  }
});
Object.defineProperty(RcMessage, "renderElement", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value(type, params) {
    var div = document.createElement("div");

    var _message = _reactDom.default.render(_react.default.createElement(RcMessage, _extends({
      type: type
    }, params)), div);

    var dom = document.querySelector(".".concat(prefix)).appendChild(div);
    _message._container = div;
    _message._dom = dom;
  }
});


// WEBPACK FOOTER //
// ./~/rc-message/lib/index.js